(function () {
  'use strict';
  var routes = window.jjRoutes || { cartAdd: '/cart/add', cart: '/cart' };
  function rupees(cents) {
    var n = Math.round(Number(cents) / 100);
    return '₹' + n.toLocaleString('en-IN');
  }
  function qs(el, s) { return el.querySelector(s); }
  function qsa(el, s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;

  /* ---------- Analytics ----------
     Shopify records the standard funnel automatically through Customer events:
     page_viewed, product_viewed, product_added_to_cart, checkout_started,
     checkout_completed. These custom bn_* events add the detail those miss
     (which pack, which button, video plays, FAQ opens) for any pixel in
     Settings > Customer events. */
  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('bn_' + name, data || {});
      }
    } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-jj-track]');
    if (t) track(t.getAttribute('data-jj-track'), { source: t.getAttribute('data-jj-src') || '', href: t.getAttribute('href') || '' });
    var wa = e.target.closest && e.target.closest('.jj-wa');
    if (wa) track('whatsapp_click', { source: 'floating_button' });
  });

  /* Section impressions (e.g. did people reach the pack cards?) */
  if ('IntersectionObserver' in window) {
    var impObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { track(en.target.getAttribute('data-bn-impression'), { path: location.pathname }); impObs.unobserve(en.target); }
      });
    }, { threshold: 0.35 });
    qsa(document, '[data-bn-impression]').forEach(function (el) { impObs.observe(el); });
  }

  /* ---------- Videos ---------- */
  var played = {};
  function trackPlay(v, where) {
    v.addEventListener('play', function () { if (!played[where]) { played[where] = true; track('video_play', { source: where }); } });
  }
  // Hero: autoplays muted; stop it for visitors on data saver or reduced motion.
  qsa(document, '[data-bn-autoplay] video').forEach(function (v) {
    if (reduceMotion || saveData) { v.removeAttribute('autoplay'); v.pause(); v.controls = true; }
    trackPlay(v, 'hero');
  });
  // Demonstration videos: play muted only while on screen.
  function playWhenVisible(v, where) {
    trackPlay(v, where);
    if (!('IntersectionObserver' in window) || reduceMotion || saveData) return;
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      if (en.isIntersecting && en.intersectionRatio > 0.6) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else if (!v.paused) { v.pause(); }
    }, { threshold: [0, 0.6, 1] }).observe(v);
  }
  qsa(document, '[data-bn-inview-play] video').forEach(function (v) { playWhenVisible(v, 'how_it_works'); });
  qsa(document, '.jj-gal__s--video video').forEach(function (v) { playWhenVisible(v, 'product_gallery'); });

  /* ---------- Toast ---------- */
  var toast = document.querySelector('[data-jj-toast]');
  var toastTimer;
  function showToast(text) {
    if (!toast) return;
    qs(toast, '[data-jj-toast-text]').textContent = text;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 7000);
  }
  if (toast) {
    qs(toast, '[data-jj-toast-close]').addEventListener('click', function () { toast.hidden = true; });
  }

  /* ---------- Cart count ---------- */
  function refreshCount() {
    return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        qsa(document, '[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      })
      .catch(function () {});
  }

  function addToCart(id, qty) {
    return fetch(routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(qty) || 1 }] })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { throw new Error(data.description || data.message || 'Could not add to cart'); }
        return data;
      });
    });
  }

  /* ---------- Buy box (variant + qty + add) ---------- */
  qsa(document, '[data-jj-buy]').forEach(function (box) {
    var form = qs(box, '[data-jj-form]');
    if (!form) return;
    var idInput = qs(form, '[data-jj-id]');
    var priceEl = qs(box, '[data-jj-price]');
    var compareEl = qs(box, '[data-jj-compare]');
    var saveEl = qs(box, '[data-jj-save]');
    var stockEl = qs(box, '[data-jj-stock]');
    var atc = qs(form, '[data-jj-atc]');
    var buyNow = qs(form, '[data-jj-buynow]');
    var err = qs(form, '[data-jj-err]');
    var qtyInput = qs(form, 'input[name="quantity"]');
    var isMain = !!box.closest('[data-jj-main-product]');
    var source = isMain ? 'product_page' : 'homepage';

    function setVariant(radio, userAction) {
      var price = Number(radio.dataset.price);
      var compare = Number(radio.dataset.compare);
      var available = radio.dataset.available === 'true';
      var inv = Number(radio.dataset.inv);
      idInput.value = radio.value;
      priceEl.textContent = rupees(price);
      if (compare > price) {
        compareEl.textContent = rupees(compare);
        saveEl.textContent = 'You save ' + rupees(compare - price);
        compareEl.hidden = false; saveEl.hidden = false;
      } else {
        compareEl.hidden = true; saveEl.hidden = true;
      }
      if (stockEl) {
        var low = inv > 0 && inv <= 10;
        stockEl.hidden = !low;
        if (low) qs(stockEl, '[data-jj-stock-n]').textContent = inv;
      }
      atc.disabled = !available; buyNow.disabled = !available;
      atc.textContent = available ? 'Add to cart' : 'Sold out';
      qsa(form, '.jj-pack').forEach(function (l) { l.classList.toggle('is-on', qs(l, 'input') === radio); });
      document.dispatchEvent(new CustomEvent('jj:variant', { detail: { price: price, id: radio.value, label: radio.dataset.label || '' } }));
      if (userAction) track('pack_selected', { variant_id: radio.value, pack: radio.dataset.label || '', price: price / 100, source: source });
      if (isMain && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url.toString());
      }
    }
    qsa(form, '.jj-pack input').forEach(function (r) {
      r.addEventListener('change', function () { setVariant(r, true); });
    });

    var qtyWrap = qs(form, '[data-jj-qty]');
    if (qtyWrap) {
      qsa(qtyWrap, 'button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = (parseInt(qtyInput.value, 10) || 1) + Number(b.dataset.step);
          qtyInput.value = Math.min(5, Math.max(1, v));
        });
      });
      qtyInput.addEventListener('change', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.min(5, Math.max(1, v));
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var isBuyNow = e.submitter && e.submitter.hasAttribute('data-jj-buynow');
      var btn = isBuyNow ? buyNow : atc;
      var label = btn.textContent;
      var qty = qtyInput ? qtyInput.value : 1;
      btn.disabled = true; btn.textContent = 'Adding…';
      err.hidden = true;
      track(isBuyNow ? 'buy_now_click' : 'add_to_cart_click', { variant_id: idInput.value, quantity: Number(qty), source: box.dataset.jjSticky ? 'sticky' : source });
      addToCart(idInput.value, qty)
        .then(function () {
          if (isBuyNow) { window.location.href = '/checkout'; return; }
          refreshCount();
          showToast('Added to your cart');
        })
        .catch(function (ex) { err.textContent = ex.message; err.hidden = false; track('add_to_cart_error', { message: ex.message }); })
        .finally(function () { btn.disabled = false; btn.textContent = label; delete box.dataset.jjSticky; });
    });
  });

  /* ---------- Quick add (pack cards on homepage) ---------- */
  qsa(document, '[data-jj-quick-add]').forEach(function (b) {
    b.addEventListener('click', function () {
      var label = b.textContent;
      b.disabled = true; b.textContent = 'Adding…';
      track('add_to_cart_click', { variant_id: b.dataset.jjQuickAdd, quantity: 1, source: 'pack_cards', pack: b.dataset.name || '' });
      addToCart(b.dataset.jjQuickAdd, 1)
        .then(function () { refreshCount(); showToast((b.dataset.name || 'Pack') + ' added to your cart'); })
        .catch(function (ex) { showToast(ex.message); })
        .finally(function () { b.disabled = false; b.textContent = label; });
    });
  });

  /* ---------- Swipe gallery (phones swipe, desktop thumbnails) ---------- */
  qsa(document, '[data-jj-gallery]').forEach(function (g) {
    var track_ = qs(g, '[data-jj-track]');
    if (!track_) return;
    var slides = qsa(track_, '.jj-gal__s');
    var idx = qs(g, '[data-jj-idx]');
    var dots = qsa(g, '.jj-gal__dots i');
    var thumbs = qsa(g, '[data-jj-go]');
    var watch = qs(g, '[data-bn-goto]');
    var seen = {};
    function mark(i) {
      if (idx) idx.textContent = i + 1;
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      if (watch) watch.hidden = slides[i] && slides[i].classList.contains('jj-gal__s--video');
      if (i > 0 && !seen[i]) { seen[i] = true; track('gallery_image_viewed', { index: i + 1 }); }
    }
    function go(i) {
      track_.scrollTo({ left: i * track_.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      mark(i);
    }
    var raf;
    track_.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track_.scrollLeft / track_.clientWidth);
        mark(Math.max(0, Math.min(slides.length - 1, i)));
      });
    }, { passive: true });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(Number(t.dataset.jjGo)); });
    });
    if (watch) {
      watch.addEventListener('click', function () {
        var i = Number(watch.dataset.bnGoto);
        go(i);
        var v = slides[i] && qs(slides[i], 'video');
        if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
    }
  });

  /* ---------- Sticky add-to-cart: shows whenever the main button is off screen ---------- */
  var sticky = document.querySelector('[data-jj-sticky]');
  var mainAtc = document.querySelector('[data-jj-main-product] [data-jj-atc]');
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    var stickySeen = false;
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      // Only after the shopper has scrolled past the button, not before it loads into view.
      var show = !en.isIntersecting && en.boundingClientRect.top < 0;
      sticky.hidden = !show;
      if (show && !stickySeen) { stickySeen = true; track('sticky_atc_shown', {}); }
    }, { rootMargin: '0px 0px -40px 0px' }).observe(mainAtc);
    qs(sticky, '[data-jj-sticky-btn]').addEventListener('click', function () {
      if (mainAtc.disabled) return;
      var box = mainAtc.closest('[data-jj-buy]');
      if (box) box.dataset.jjSticky = '1';
      mainAtc.click();
    });
    document.addEventListener('jj:variant', function (e) {
      var p = qs(sticky, '[data-jj-sticky-price]');
      if (p) p.textContent = rupees(e.detail.price) + (e.detail.label ? ' · ' + e.detail.label : '');
    });
  }

  /* ---------- Write a review ---------- */
  qsa(document, '[data-jj-write-review]').forEach(function (b) {
    b.addEventListener('click', function () {
      var target = document.getElementById('jj-reviews');
      if (target) target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      var jdgm = document.querySelector('.jdgm-write-rev-link');
      if (jdgm) { setTimeout(function () { jdgm.click(); }, 400); return; }
      if (b.dataset.mailto) { window.location.href = b.dataset.mailto; }
    });
  });

  /* ---------- FAQ opens (what are people unsure about?) ---------- */
  qsa(document, '.jj-faq details').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) { var s = qs(d, 'summary'); track('faq_opened', { question: s ? s.textContent.trim() : '' }); }
    });
  });

  /* ---------- Cart page quantity buttons ---------- */
  qsa(document, '[data-jj-cart-qty]').forEach(function (w) {
    var input = qs(w, 'input');
    qsa(w, 'button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = (parseInt(input.value, 10) || 0) + Number(b.dataset.step);
        input.value = Math.min(5, Math.max(0, v));
        input.form.submit();
      });
    });
  });
})();
